@if (data$ | async; as data) {
  @if (data.urlLink && (data.urlLink | json) != '{}') {
    <cx-generic-link
      [url]="data.urlLink"
      [target]="getTarget(data)"
      >
      <ng-container *ngTemplateOutlet="content">
      </ng-container>
    </cx-generic-link>
  } @else {
    @if (data.headline) {
      <p class="headline" [innerHTML]="data.headline"></p>
    }
    <cx-media [container]="data.media"></cx-media>
    @if (data.content) {
      <p class="content" [innerHTML]="data.content"></p>
    }
  }
  <ng-template #content>
    @if (data.headline) {
      <p class="headline" [innerHTML]="data.headline"></p>
    }
    <cx-media [container]="data.media"></cx-media>
    @if (data.content) {
      <p class="content" [innerHTML]="data.content"></p>
    }
  </ng-template>
}

